/**
 * Template-gallery, signup-consent, legal-page and cookie-notice slice of the
 * English catalog.
 *
 * Imported through enCampaigns.ts (same import line in en.ts) because en.ts
 * sits one line under the 500-line fileSize ceiling.
 */
export const enTemplates = {
  // ── Template gallery ("Use template") ─────────────────────────────────
  'templates.createdFromRecommended': 'Created "{name}" from a recommended flow',
  'templates.campaignDraftCreated': 'Created the draft campaign "{name}" — edit it, choose who gets it, then send or schedule it.',
  'templates.packInstalled': 'Installed "{name}" as drafts — review it in My flows, then activate it.',
  'templates.unavailable': 'This template could not be created. Pick another template, or build the flow from scratch in the canvas.',
  'templates.recommendedTitle': 'Recommended for your business',
  'templates.recommendedHintBefore': 'Tailored for',
  'templates.recommendedHintAfter': '· set in Account → Business kind',
  'templates.starterPack': 'STARTER PACK',
  'templates.featureTriggers': 'Triggers this kind features',
  'templates.intro': 'Start from a trigger. Every template works across email, chat and on-site — design it once, activate it as a flow.',
  'templates.searchPlaceholder': 'Search templates…',
  'templates.use': 'Use',
  'templates.design': 'Design',
  'templates.emptyTitle': 'No templates match',
  'templates.emptyBody': 'Try a different channel filter or clear your search.',
  'templates.resetFilters': 'Reset filters',
  'templates.activateFailed': 'Failed to create from template',
  'templates.triggerPrefix': 'Trigger · {trigger}',
  'packs.emptyTitle': 'No packs for this filter',
  'packs.emptyBody': 'Try another business kind, or show all packs.',
  'packs.resetFilters': 'Show all packs',
  // ── Login 2FA step (shown only when the server requires a code) ────────
  'login.twoFactor.title': 'Two-factor authentication',
  'login.twoFactor.body': 'Enter the 6-digit code from your authenticator app, or one of your backup codes.',
  'login.twoFactor.codeLabel': 'Verification code',
  'login.twoFactor.verify': 'Verify',
  'login.twoFactor.verifying': 'Verifying…',
  'login.twoFactor.cancel': 'Cancel',
  'login.twoFactor.invalid': 'Invalid verification code. Please try again.',
  'login.twoFactor.required': 'Enter your verification code.',
  'login.noAccount': "Don't have an account?",
  'login.createAccount': 'Create an account',
  // ── Signup marketing opt-in (unchecked by default) ────────────────────
  'signup.marketingOptIn': 'Send me product tips and updates',
  'signup.marketingOptInHint': 'Optional. You can unsubscribe from any email.',
  // ── Signup heading ────────────────────────────────────────────────────
  'signup.subtitle': 'Get started with your free account.',
  // ── Signup legal agreement ({terms}/{privacy} become links) ───────────
  'signup.agreeToTerms': 'I agree to the {terms} and the {privacy}',
  'signup.googleAgreement': 'By signing up with Google, you agree to the {terms} and the {privacy}.',
  // ── Legal pages (the texts are static pages in client/public) ─────────
  'legal.termsLink': 'Terms of Service',
  'legal.privacyLink': 'Privacy Policy',
  'legal.cookiesLink': 'Cookie Policy',
  'legal.openDocument': 'Open the {title}',
  'legal.loadingDocument': 'Loading…',
  'legal.toc': 'Table of Contents',
  'legal.effective': 'Effective: {date}',
  'legal.lastUpdated': 'Last Updated: {date}',
  'legal.backToTop': 'Back to top',
  // ── Cookie notice (nothing optional loads, so it is a notice, not a choice)
  'cookieNotice.body': 'This site uses only the cookies and browser storage it needs to work, and no analytics or advertising cookies. Its pages load Facebook\'s SDK, so you can connect Facebook and Instagram, and Google Fonts; both receive your IP address.',
  'cookieNotice.ok': 'Got it',
} as const;
